import {
  alpha,
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'

import rem, { getWhiteOrBlackTextColorByBackground } from '~/utils/ui'

type TProps = {
  open: boolean
  accentColor: string
  onImDone: () => void
  onKeepChatting: () => void
  onHideForNow: () => void
}

function EndChatDialog({
  open,
  accentColor,
  onImDone,
  onKeepChatting,
  onHideForNow,
}: TProps) {
  const theme = useTheme()
  const imDoneTextColor = getWhiteOrBlackTextColorByBackground(
    accentColor,
    theme,
  )

  return (
    <Dialog
      open={open}
      onClose={onKeepChatting}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: alpha(theme.palette.mainFont, 0.35),
          },
        },
      }}
      PaperProps={{
        sx: {
          '&.MuiPaper-root': {
            borderRadius: rem(20),
          },
          padding: rem(8),
          margin: rem(20),
          marginTop: rem(24),
          // maxWidth: rem(360),
          width: '100%',
        },
      }}
    >
      <DialogContent sx={{ padding: 1.5 }}>
        <Stack gap={2}>
          <Stack gap={0.5}>
            <Typography
              sx={{
                fontSize: rem(20),
                fontWeight: theme.typography.fontWeightBold,
                color: theme.palette.mainFont,
              }}
            >
              Leaving the chat?
            </Typography>
            <Typography
              sx={{
                fontSize: rem(15),
                color: theme.palette.mainFont,
              }}
            >
              Minimize it to come back and continue in the next few minutes, or
              end the conversation if you&apos;re finished.
            </Typography>
          </Stack>

          <Stack direction="row" gap={1.5}>
            <Button
              onClick={onKeepChatting}
              sx={{
                flex: 1,
                borderRadius: rem(48),
                padding: `${rem(10)} ${rem(16)}`,
                textTransform: 'none',
                fontSize: rem(15),
                height: rem(40),
                fontWeight: theme.typography.fontWeightMedium,
                color: theme.palette.mainFont,
                backgroundColor: theme.palette.common.white,
                border: `${rem(1)} solid ${theme.palette.tertiary5}`,
                '&:hover': {
                  backgroundColor: theme.palette.tertiary5,
                },
              }}
            >
              Keep chatting
            </Button>
            <Button
              onClick={onImDone}
              sx={{
                flex: 1,
                borderRadius: rem(48),
                padding: `${rem(12)} ${rem(16)}`,
                textTransform: 'none',
                fontSize: rem(15),
                height: rem(40),
                fontWeight: theme.typography.fontWeightMedium,
                color: imDoneTextColor,
                backgroundColor: accentColor,
                '&:hover': {
                  backgroundColor: accentColor,
                  opacity: 0.9,
                },
              }}
            >
              End conversation
            </Button>
          </Stack>

          <Stack direction="row" justifyContent="center">
            <Button
              onClick={onHideForNow}
              disableRipple
              sx={{
                textTransform: 'none',
                fontSize: rem(14),
                height: rem(40),
                fontWeight: theme.typography.fontWeightMedium,
                color: accentColor,
                backgroundColor: theme.palette.common.white,
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'underline',
                },
              }}
            >
              Minimize chat
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default EndChatDialog
